import React, { Fragment, Component } from "react";

import Slider from "react-slick";

import conference from "../../../assets/utils/images/top-img.png";
import live_call from "../../../assets/utils/images/live-calls.png";
import video_api from "../../../assets/utils/images/video-api.png";
import video_kiosk from "../../../assets/utils/images/video-kiosk.png";

import { withRouter } from "react-router";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import { auth } from "../../../Auth/Firebase";
import { logout } from "../../../Helpers/User";
import { getAuthUser, resetToken } from "../../../States/Token";
import { get_landing_page } from "../../../Helpers/Router";

class VerifyEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email_sent: false,
      message: "",
    };

    this.signInWithEmailAndPasswordHandler =
      this.signInWithEmailAndPasswordHandler.bind(this);
    this.resend_verification_email = this.resend_verification_email.bind(this);
  }

  componentDidMount() {
    resetToken();
    this.resend_verification_email();
  }

  resend_verification_email() {
    this.setState({message: ""});
    getAuthUser()
      .sendEmailVerification({
        url: "https://my.saleassist.ai",
      })
      .then((response) => {
        this.setState({ email_sent: true });
        setTimeout(() => this.setState({ email_sent: false }), 4000);
      })
      .catch((error) => this.setState({ message: error.message }));
  }

  signInWithEmailAndPasswordHandler = (event, email, password) => {
    event.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .then((response) => {
        // this.props.history.push(get_landing_page());
      })
      .catch((error) => {
        bottomAlert("Error signing in with email and password!", "warning");
      });
  };

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
    };
    return (
      <Fragment>
        <div className="login-main">
        <div className="login-video">
  <video
    autoPlay
    loop
    muted
    className="sample-video h-100 no-gutters"
  >
    <source
      src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/hb-opt.mp4"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
</div>
<div className="login-form">
<Row className="h-100 no-gutters">
            {/* <Col lg="4" className="d-none d-lg-block">
              <div className="slider-dark">
                <Slider {...settings}>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div
                      className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + conference + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div className="slider-content">
                      <h3>Secure video conferencing</h3>
                      <p>
                        Secure and safe environment customized with your
                        company's brand logo and theme.
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div
                      className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + video_api + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div className="slider-content">
                      <h3>API driven. Build. Experience.</h3>
                      <p>
                        SaleAssist can be integrated into any of your business
                        process, e.g integration with ERP or a Ticketing system.
                        We have Transactional Video call APIs by which you can
                        have on-demand video call generated, programatically !
                        Whether you are an enterprise or a startup, we have
                        solutions for all scale. These are REST APIs and have
                        simple integration.
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div
                      className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + live_call + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div className="slider-content">
                      <h3>Live Calls</h3>
                      <p>
                        Live Call gets plugged in to your application and
                        enables direct video calling. Let it be website or a
                        custom application, with just inserting few lines of
                        code , Live Call makes your frontend video call enabled.
                        It’s that simple ! Features include multiple agent
                        management, reports & analytics and did we mention your
                        first 100 Video calls are on us!
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-light">
                    <div
                      className="slide-img-bg opacity-1"
                      style={{
                        backgroundImage: "url(" + video_kiosk + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div className="slider-content">
                      <h3>Video Kiosk</h3>
                      <p>
                        In times of social distancing, video kiosk offers
                        immense value to engage & interact with your walk in
                        customers. Have live video conversation with visitors
                        while your customer representatives may be remotely
                        working. Did we mention earlier that all conversations
                        get recorded for quality purposes
                      </p>
                    </div>
                  </div>
                </Slider>
              </div>
            </Col> */}
            <Col
              lg="12"
              md="12"
              className="h-100 d-flex bg-white justify-content-center align-items-center"
            >
              <Col lg="9" md="10" sm="12" className="mx-auto app-login-box" style={{textAlign: "center"}}>
                {/* <div className="app-block-logo" /> */}
                <div> <img
                src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/sa-new-Logo.png"
                alt="SaleAssist Logo"
                style={{ width: "200px",marginRight:"auto"}} // Set size and margin for logo
              />
              </div>
                <h4 className="mb-0" >
                  Welcome to SaleAssist,
                </h4>
                <Row className="divider" />
                <h6 className="mt-3">
                  Please verify your email address. Click on the verification
                  link in the email we have sent you. <br />
                  <br />
                  Not received the email yet?{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      this.resend_verification_email();
                    }}
                    className="text-primary"
                    style={{fontSize:"15px",fontWeight:"bolder",color:"black"}}
                  >
                    Resend verification email.
                  </a>{" "}
                  <span className="text-warning">
                    {this.state.email_sent ? "Email sent" : ""}
                  </span>
                </h6>
                <Row className="divider" />
                <h6 className="mt-3 text-danger">{this.state.message}</h6>
                <h6 className="mt-3">
                  Post verification, try signing again.{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      logout();
                    }}
                    style={{fontSize:"15px",fontWeight:"bolder",color:"black"}}
                    className="text-primary"
                  >
                    Sign in
                    <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }}></i>
                  </a>
                </h6>
              </Col>
            </Col>
          </Row>
</div>
          
        </div>
      </Fragment>
    );
  }
}

export default withRouter(VerifyEmail);
